import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import WithRouter from '../../hoc/WithRouter';
import VideoConfigService from '../../services/VideoConfigService';
import WithRoutify from '../../hoc/WithRoutify';

function VideoPlayer(props) {
  const [videos, setVideos] = useState([]);
  const [loadedCount, setLoadedCount] = useState(0);

  useEffect(() => {
    let location = props.location.pathname || ""
    const path = location.split("/").filter(Boolean)
     console.log("path", path);
    location = path
    if (path.length >= 2) {
      const baseurl = getbaseURL(path)
      console.log("location", baseurl);

      location = baseurl
    }
    fetchData(location)

  },[])
  const getbaseURL=(data)=>{
    return `${data.slice(0, 2).join("/")}`;
  };

  const fetchData = async (url) => {
    try {
      props.Loader(true);
      setLoadedCount(0);
      const response = await VideoConfigService.getByScreen(url);
      if (response && response.length > 0) {
        setVideos(response);
      } else {
        setVideos([]);
        props.Loader(false);
      }
    } catch (err) {
      props.Loader(false);
      props.Toast.error("something went wrong");
    }
  };

  const handleIframeLoad = () => {
    setLoadedCount((count) => {
      const next = count + 1;
      if (next >= videos.length) props.Loader(false);
      return next;
    });
  };

  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const validVideos = videos
    .filter((v) => v.video_url && isValidUrl(v.video_url));

  return (
    <Modal
      show={true}
      onHide={props.tutorialToogleHandler}
      size="lg"
      dialogClassName="hResponsive"
      contentClassName="h-80"
      backdrop="static"
      keyboard={false}
    >
      <div className="sh_modalBox">
        <Modal.Header closeButton>
          <Modal.Title>
            <h6 className="font-weight-bold text-lg mb-0">{"Tutorial Video"}</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {validVideos.length > 0 ? (
            <div className="d-flex flex-column gap-4">
              {validVideos.map((item, index) => (
                <div
                  key={item.tutorial_id || index}
                  className="rounded border bg-light"
                  style={{
                    padding: "1rem",
                    borderColor: "#e9ecef !important",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <span
                      className="rounded-circle d-inline-flex align-items-center justify-content-center fw-bold text-white"
                      style={{
                        width: "28px",
                        height: "28px",
                        fontSize: "0.85rem",
                        backgroundColor: "#6366f1",
                      }}
                    >
                      {index + 1}
                    </span>
                    {item.description ? (
                      <h6 className="mb-0 text-dark">{item.description}</h6>
                    ) : (
                      <h6 className="mb-0 text-dark">
                        Tutorial Video {index + 1}
                      </h6>
                    )}
                  </div>
                 <div
                    className="rounded overflow-hidden bg-dark position-relative"
                    style={{ width: "100%", paddingTop: "56.25%" }} // 16:9 ratio
                  >
                    <iframe
                      src={item.video_url}
                      title={item.description || `Tutorial Video ${index + 1}`}
                      allow="autoplay; picture-in-picture"
                      allowFullScreen
                      loading="eager"
                      onLoad={handleIframeLoad}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: 0,
                      }}
                    />
                  </div>

                </div>
              ))}
            </div>
          ) : videos.length > 0 ? (
            <div className="">Invalid URL</div>
          ) : (
            <div className="row">No data Found</div>
          )}
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default WithRouter(WithRoutify(VideoPlayer));